// Helpers for endpoints that answer with a real file (axios responseType "blob").

export function saveBlob(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/** File name from the response's Content-Disposition header (backend must expose it), else the fallback. */
export function fileNameFromHeaders(headers: any, fallback: string): string {
  const disposition = String(headers?.["content-disposition"] ?? "");
  return /filename="?([^"]+)"?/.exec(disposition)?.[1] ?? fallback;
}

/** Backend message of a failed request; blob requests carry the JSON error body as a Blob. */
export async function blobErrorMessage(error: any, fallback: string): Promise<string> {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      return json?.message || json?.detail || fallback;
    } catch {
      return fallback;
    }
  }
  return data?.message || error?.message || fallback;
}
